module.exports = __webpack_public_path__ + "media/newstyle/images/icon-questionmark-bca10d9fcc10004c1a4c86bd05dda46a.svg";